<template>
  <div>
  <!--Test Log in-->
    <div v-if="!userLogin.name">
    <TextField
        placeholder="email"
        :value="login_form.email"
        @onChange="login_form.email = $event"
    ></TextField>
    <TextField
        placeholder="password"
        type="password"
        :value="login_form.password"
        @onChange="login_form.password = $event"
        @onEnter="login"
    ></TextField>
    <Button @onClick="login">Login</Button>
    </div>
    <div v-else>
      {{ userLogin.name }}
      <Button @onClick="logout">Logout</Button>
    </div>
  </div>
</template>

<script>
import TextField from "../components/input/TextField";
import Button from "../components/input/Button";
import {getCookie__c} from "../plugins/cookies";
import {eventBus} from "../plugins/global-funcs";
import {mapState} from "vuex";
export default {
  name: 'Home',
  components: {
    TextField,
    Button
  },
  data() {
    return {
      login_form:{
        email: 'pichetkunakorn.s@gmail.com',
        password: 'ksks1234'
      }
    }
  },
  computed: {
    ...mapState({
      userLogin: state => state.Auth.User
    })
  },
  methods:{
    async login() {
      console.log('payload: ', this.login_form)
      let res = await this.$apiFire('Auth/login', this.login_form)
      console.log('login: ', res)
      await this.$apiFire('Auth/getUser')
    },
    async logout() {
      await this.$apiFire('Auth/logout')
      this.$store.commit('Auth/clearUserInfo')
    }
  }
}
</script>
